import React,{useState} from 'react';
import { MdVerifiedUser } from "react-icons/md";
import EditField from './EditField';
import { successToaster, ErrorToaster } from "../../../../utils/toaster";
import { makeApiCall } from "../../../../config";
import ErrorBorder from '../../../../components/Alerts/ErrorBorder';



export default function Profile({ userInfo }) {
  const [enableAddUrlAndEnvBtn, setEnableAddUrlAndEnvBtn] = useState(false);
  const [fields, setFields] = useState({
    username: userInfo?.username,
    email: userInfo?.email,
    mobileNumber: userInfo?.mobileNumber,
    organizationName: userInfo?.organizationName,
    organizationRoll: userInfo?.organizationRoll,
    baseURL: userInfo?.baseURL || [],
    environment: userInfo?.environment || [],
    defaultEnv: userInfo?.defaultEnv,
    defaultURL: userInfo?.defaultURL,
    listOfUrlAndEnv: userInfo?.listOfUrlAndEnv
  });
  const handleChange = (e, multifieldName, multifieldValue) => {
    if (!e && multifieldName && multifieldValue) {
      const result = fields?.listOfUrlAndEnv.find((item) => item[multifieldName] == multifieldValue.value);
      console.log("find result :", result);
      if (multifieldName === 'environment') {
        setFields({
          ...fields,
          defaultEnv: result.environment,
          defaultURL: result.baseURL
        })
      }
      if (multifieldName === 'baseURL') {
        setFields({
          ...fields,
          defaultEnv: result.environment,
          defaultURL: result.baseURL
        })
      }
      return;
    }
    const { name, value } = e.target;
    setFields({
      ...fields,
      [name]: value
    });
  }
  const handleSubmit = async (param) => {
    try {
      if (!userInfo._id) {
        throw new Error("user not found");
      }
      const response = await makeApiCall(`/api/v1/user/edit/${userInfo._id}`, 'put', param);
      const { message } = response;
      successToaster(message);
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        ErrorToaster("please try later");
        console.log('error occurred in edit user info ', error);
      }
    }
  }

  return (
    <>
      <div>
        <h2 className="text-base font-semibold leading-7 text-gray-900">Profile</h2>
        <p className="mt-1 text-sm leading-6 text-gray-500">
          This information will be displayed publicly so be careful what you share.
        </p>

        <dl className="mt-6 space-y-6 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
          <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} name={"username"} value={fields.username} title={"Full Name"} />
          <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"email"} name={"email"} value={fields.email} title={"Email Address"} disable={false} />
          <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} name={"mobileNumber"} value={fields.mobileNumber} title={"Phone No"} />
          <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} name={"organizationName"} value={fields.organizationName} title={"Organization"} />
          <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} name={"organizationRoll"} value={fields.organizationRoll} title={`Roll at ${fields.organizationName || "Organization"}`} />
          <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} value={fields.emailVerified ? <span className='text-green-500'><MdVerifiedUser className='text-lg' /></span> : 'Not verified'} title={"Email Verified"} disable={false} />
          {fields.defaultURL && <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} name={"defaultURL"} value={fields.defaultURL} title={"Domain URL"} disable={false} />}
          {fields.defaultEnv && <EditField handleSubmit={handleSubmit} handleChange={handleChange} setFields={setFields} type={"text"} name={"defaultEnv"} value={fields.defaultEnv} user={fields} title={"Domain Environment"} fields={fields} disable={false} enableAddUrlAndEnvBtn={enableAddUrlAndEnvBtn} setEnableAddUrlAndEnvBtn={setEnableAddUrlAndEnvBtn} />}
          <EditField handleSubmit={handleSubmit} title={"List of URL & Environment"} handleChange={handleChange} setFields={setFields} multifield={true} user={fields} enableAddUrlAndEnvBtn={enableAddUrlAndEnvBtn} setEnableAddUrlAndEnvBtn={setEnableAddUrlAndEnvBtn} />
          {!fields.defaultURL && !fields.defaultEnv && <ErrorBorder message={"Please choose your default URL And ENV"}/>}
        </dl>
      </div>
    </>
  )
}
